import operationMasterService from "@/services/operations/operationMasterService";
import mapKeys from "lodash/mapKeys";

// オペレーション管理マスタ（港・貨物種類）。PORT_HIERARCHY_PICKER / CARGO_PICKER の ID→名称解決に使う
const INITIAL_STATE = {
  ports: [],
  cargoTypes: [],
  portsLoaded: false,
  cargoTypesLoaded: false,
};

export default {
  isRegistered: false,
  namespaced: true,

  state: {
    ...INITIAL_STATE,
  },

  mutations: {
    SET_PORTS(state, ports) {
      state.ports = Array.isArray(ports) ? ports : [];
      state.portsLoaded = true;
    },
    SET_CARGO_TYPES(state, cargoTypes) {
      state.cargoTypes = Array.isArray(cargoTypes) ? cargoTypes : [];
      state.cargoTypesLoaded = true;
    },
    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },

  actions: {
    // 港マスタを取得（取得済みなら何もしない）。失敗してもエラーを握りつぶす（ID 表示にフォールバック）。
    async setPorts({ commit, state }) {
      if (state.portsLoaded) return;
      try {
        const ports = await operationMasterService.getPorts();
        commit("SET_PORTS", ports);
      } catch {
        // 取得失敗時は名称解決せず ID 表示にフォールバック
      }
    },

    // 貨物種類マスタを取得（取得済みなら何もしない）。失敗は握りつぶす。
    async setCargoTypes({ commit, state }) {
      if (state.cargoTypesLoaded) return;
      try {
        const cargoTypes = await operationMasterService.getCargoTypes();
        commit("SET_CARGO_TYPES", cargoTypes);
      } catch {
        // 取得失敗時は ID 表示にフォールバック
      }
    },

    // レポート表示時に港・貨物マスタをまとめて確保する。
    async ensureMasters({ dispatch }) {
      await Promise.all([dispatch("setPorts"), dispatch("setCargoTypes")]);
    },

    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },

  getters: {
    ports: state => (Array.isArray(state.ports) ? state.ports : []),
    cargoTypes: state =>
      Array.isArray(state.cargoTypes) ? state.cargoTypes : [],

    // port_id -> port
    portMapById: (_state, getters) => mapKeys(getters.ports, "id"),

    // port_district_id -> district（全港の地区を平坦化）
    portDistrictMapById: (_state, getters) => {
      const map = {};
      getters.ports.forEach(port => {
        (port.districts || []).forEach(district => {
          if (district && district.id != null) {
            map[String(district.id)] = district;
          }
        });
      });
      return map;
    },

    // port_berth_id -> berth（全地区のバースを平坦化）
    portBerthMapById: (_state, getters) => {
      const map = {};
      getters.ports.forEach(port => {
        (port.districts || []).forEach(district => {
          (district.berths || []).forEach(berth => {
            if (berth && berth.id != null) {
              map[String(berth.id)] = berth;
            }
          });
        });
      });
      return map;
    },

    // cargo_type_id -> cargoType
    cargoTypeMapById: (_state, getters) => mapKeys(getters.cargoTypes, "id"),

    // 表示整形（formatReportValueForDisplay）へまとめて渡すためのマップ束
    masterMaps: (_state, getters) => ({
      portMap: getters.portMapById,
      districtMap: getters.portDistrictMapById,
      berthMap: getters.portBerthMapById,
      cargoMap: getters.cargoTypeMapById,
    }),
  },
};
